import { BrowserRouter, Route, Routes, Navigate} from "react-router-dom";
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import Signup from "./pages/SignupPage";
import OtpVerify from "./pages/OtpPage";
import FamilyVerify from "./components/FamilyVerify";
import Verify from "./components/Verify";
import LanguageState from "./context/language/LanguageState";
import Profile from "./pages/ProfilePage";
import QuestionPage from "./pages/QuestionPage";
import SessionTimeoutPopup from "./components/Session";
import Alert from "./components/Alert";
import Checklist from "./pages/Checklist";
import Booking from "./pages/Booking";
import LabBook from "./pages/LabBooking";
import Buymedicine from "./pages/Buymedicine";
import Carebuddy from "./pages/Carebuddy";
import Reminderbook from "./pages/Reminderbooking"

import Generalsearch from "./pages/Generalsearch";
import DoctorDeatils from "./pages/DoctorDeatils";
import MedicineChatbot from "./components/MedicineChatbot";
import CouponAndPayment from "./components/CouponAndPayment";
import SubscriptionSelector from "./components/SubscriptionSelector";
import MedicineReminderUploader from "./pages/MedicineReminderUploader";
import ImageAnalysis from "./components/ImageAnalysis";
import SearchHospitals from "./components/SearchHospitals";
import languageContext from "./context/language/LanguageState";
import ReminderPreference from "./pages/ReminderPreference";
import PurposeSelection from "./components/PurposeSelection";
import FamilyLogin from "./pages/FamilyLogin";
import FamilyOtpVerify from "./pages/FamilyOtpVerify";
import FamilySubscriptionSelector from "./components/FamilySubscriptionSelector";
import LabReportAnalysis from "./components/LabReportAnalysis";
import HumanImageAnalyzer from "./components/MedicalImageAnalyzer";
import RPPGWebcam from "./components/RPPGWebcam";
import PatientDashboard from "./components/PatientDashboard";
import PrescriptionDetails from "./components/PrescriptionDetails";
import PatientAppointments from "./components/PatientAppointment";
import PatientLabBookings from "./components/PatientLabBookings";
import PatientAllMedicineOrdersView from "./components/PatientMedicineOrders";
import TermsAndConditions from "./pages/TermsAndConditions"
import RefundPolicy from "./pages/RefundPolicy"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import MasterPrivacyPolicy from "./pages/MasterPrivacyPolicy"
import ConsentPolicy from "./pages/ConsentPolicy"
import MedicalDisclaimer from "./pages/MedicalDisclaimer"
import AIDisclaimer from "./pages/AIDisclaimer"
import CookiePolicy from "./pages/CookiePolicy"
import DataRetentionPolicy from "./pages/DataRetentionPolicy"
import RegulatoryDisclaimer from "./pages/RegulatoryDisclaimer"
import PrivacyNotice from "./pages/PrivacyNotice"
import DisclaimerPage from "./pages/DisclaimerPage"
import Services from "./pages/Services"
import UserManual from "./pages/UserManual"
import ContactPage from "./pages/ContactPage"
import {API_URL,FAST_API_URL} from "./api"


  
const ProtectedRoute = ({ children, isPaid, loading }) => {
  if (loading) return <div>Loading...</div>;
  if (!isPaid) return <Navigate to="/subscription" replace />;
  return children;
};

function App() {
  const [loading, setLoading] = useState(true);
  const [isPaid, setIsPaid] =useState(false)

  // useEffect(() => {
  //   const fetchPaymentStatus = async () => {
  //     try {
  //       // const token = localStorage.getItem("authToken"); // adjust if using other storage
  //       const response = await axios.post(`${API_URL}/check_view", {
  //         patient_id: localStorage.getItem("patient_id"),
  //       });
  //       if (response.status == 200) {
  //         // If already subscribed, you might want to redirect or show info
  //         setIsPaid(true); // redirect if needed
  //       }


  //     } catch (err) {
  //       console.error("Payment status fetch failed", err);
  //       setIsPaid(false);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchPaymentStatus();
  // }, []);

useEffect(() => {

  const fetchPaymentStatus = async () => {

    const patient_id = localStorage.getItem("patient_id");
    const token = localStorage.getItem("token");

    try {

      // =====================================
      // 1. CHECK PAID USER
      // =====================================

      const paymentResponse = await axios.post(
        `${API_URL}/check_view`,
        {
          patient_id: patient_id,
        }
      );

      console.log(paymentResponse.data, "CHECK VIEW RESPONSE");

      // =====================================
      // USER ALREADY PAID
      // =====================================

      if (paymentResponse.status === 200) {

        setIsPaid(true);
        setLoading(false);

        return;

      }

    } catch (paymentError) {

      console.log("check_view failed");

      // =====================================
      // 2. CHECK FREE TRIAL
      // =====================================

      try {

        const planResponse = await axios.post(
          `${API_URL}/check-patient-plan`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log(planResponse.data, "PLAN RESPONSE");

        // =====================================
        // FREE TRIAL ACTIVE
        // =====================================

        if (planResponse.data.status_code === 200) {

          setIsPaid(true);
          setLoading(false);

        }

        // =====================================
        // PAYMENT REQUIRED
        // =====================================

        else {

          setIsPaid(false);
          setLoading(false);

        }

      } catch (planError) {

        console.log(planError.response, "PLAN ERROR");

        setIsPaid(false);
        setLoading(false);

      }

    } finally {

      setLoading(false);

    }

  };

  fetchPaymentStatus();

}, []);

  return (
    <div className="App">
      <BrowserRouter>
        <LanguageState>
          <Alert />
          <SessionTimeoutPopup />
          <Routes>
            {/* Always allowed */}
            <Route exact path="/" element={<LandingPage />} />
            <Route exact path="/login" element={<LoginPage />} />
            <Route exact path="/family_login" element={<FamilyLogin />} />
             <Route exact path="/terms" element={< TermsAndConditions/>} />
              <Route exact path="/refund" element={< RefundPolicy/>} />
            <Route exact path="/privacy" element={< PrivacyPolicy/>} />
              <Route exact path="/master_privacy" element={< MasterPrivacyPolicy/>} />
              <Route exact path="/consent_policy" element={< ConsentPolicy/>} />
              <Route exact path="/medical_disclaimer" element={< MedicalDisclaimer/>} />
               <Route exact path="/AI_disclaimer" element={< AIDisclaimer/>} />
                <Route exact path="/cookie_policy" element={< CookiePolicy/>} />
                <Route exact path="/Data_retention_policy" element={< DataRetentionPolicy/>} />
                <Route exact path="/regulatory_disclaimer" element={< RegulatoryDisclaimer/>} />
            <Route exact path="/privacy-notice" element={< PrivacyNotice/>} />
            <Route exact path="/disclaimer" element={<DisclaimerPage />} />
            <Route exact path="/disclaimer" element={<DisclaimerPage />} />
            <Route exact path="/services" element={<Services />} />
            <Route exact path="/user_manual" element={<UserManual />} />
            <Route exact path="/contact" element={<ContactPage />} />
            <Route exact path="/signup" element={<Signup />} />
            <Route exact path="/prescription" element={<ProtectedRoute isPaid={isPaid} loading={loading}>< PrescriptionDetails/></ProtectedRoute> } />
          <Route exact path="/plan" element={ <ProtectedRoute isPaid={isPaid} loading={loading}><PatientDashboard /></ProtectedRoute> }/>
          <Route exact path="/all_appointment" element={ <ProtectedRoute isPaid={isPaid} loading={loading}><PatientAppointments /></ProtectedRoute> }/>
          <Route exact path="/lab_bookings" element={ <ProtectedRoute isPaid={isPaid} loading={loading}><PatientLabBookings /></ProtectedRoute> }/>
<Route exact path="/medicine_bookings" element={ <ProtectedRoute isPaid={isPaid} loading={loading}><PatientAllMedicineOrdersView /></ProtectedRoute> }/>



            <Route
              exact
              path="/family-otp"
              element={
                <FamilyVerify>
                  <FamilyOtpVerify />
                </FamilyVerify>
              }
            />
            <Route
              exact
              path="/otp"
              element={
                <Verify>
                  <OtpVerify />
                </Verify>
              }
            />

            {/* Payment-protected routes */}
            <Route
              exact
              path="/account"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/ask/:id"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <QuestionPage />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/ask"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <QuestionPage />
                 </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/checklist"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <Checklist />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/booking"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <Booking />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/book_appointment"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <Booking />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/lab_book"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <LabBook />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/buy_medicine"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <Buymedicine />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/reminder"
              element={
                // <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <ReminderPreference />
                // </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/care_buddy"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <Carebuddy />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/general_serach"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <Generalsearch />
                </ProtectedRoute>
              }
            />
            {console.log(isPaid, "isPaid")}
            <Route
              exact
              path="/doctor_details"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <DoctorDeatils />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/medicine_chat"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <MedicineChatbot />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/coupon"
              element={
                <CouponAndPayment/>

              }
            />
            <Route
              exact
              path="/subscription"
              element={<SubscriptionSelector setIsPaid={setIsPaid} />}
            />
            <Route
              exact
              path="/family_subscription"
              element={<FamilySubscriptionSelector setIsPaid={setIsPaid} />}
            />
            <Route
              exact
              path="/reminder_upload"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <MedicineReminderUploader />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/image_analysis"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <ImageAnalysis />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/lab_report_analysis"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <LabReportAnalysis />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/search_hospital"
              element={
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <SearchHospitals />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/reminder_book"
              element={
                // <ReminderPreference/>
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <Reminderbook />
                </ProtectedRoute>
              }
            />

<Route
              exact
              path="/medical_image_analyzer"
              element={
                // <ReminderPreference/>
                <ProtectedRoute isPaid={isPaid} loading={loading}>
                  <HumanImageAnalyzer />
                </ProtectedRoute>
              }
            />
            <Route exact path="/RPPGWebcam" element={<RPPGWebcam/>}/>
            {/* </ProtectedRoute>} /> */}
            <Route exact path="/purpose" element={
            <ProtectedRoute isPaid={isPaid} loading={loading}>
            <PurposeSelection/>
            </ProtectedRoute>
            }></Route>
          </Routes>
        </LanguageState>
      </BrowserRouter>
    </div>
  );
}

export default App;
